import React, { useRef, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Label, Error, Hint } from '@progress/kendo-react-labels';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';

const parseDate = (dateString) => {
    const parsedDate = new Date(dateString);
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const CustomDatePicker = (fieldRenderProps) => {
    const {
        validationMessage,
        touched,
        label,
        id,
        valid,
        disabled,
        hint,
        optional,
        visited,
        modified,
        ...others
    } = fieldRenderProps;

    // Value-Verarbeitung für ISO-Format
    let dateValue = others.value;
    if (typeof dateValue === 'string' && dateValue.trim() !== '') {
        dateValue = parseDate(dateValue);
    }

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    const datePickerRef = useRef(null);

    useEffect(() => {
        if (datePickerRef.current) {
            const inputElement = datePickerRef.current.element.querySelector('input');
            if (inputElement) {
                inputElement.setAttribute('autocomplete', 'off');
            }
        }
    }, [datePickerRef]);

    const handleChange = (event) => {
        // Sicherstellen, dass der Wert im ISO-Format zurückgegeben wird
        others.onChange({
            value: event.value
        });
    };

    return (
        <FieldWrapper>
            <Label editorId={id} editorValid={valid} editorDisabled={disabled} optional={optional}>
                {label}
            </Label>
            <div className={'k-form-field-wrap'}>
                <DateTimePicker
                    ref={datePickerRef}
                    valid={valid}
                    id={id}
                    disabled={disabled}
                    value={dateValue instanceof Date ? dateValue : null}
                    onChange={handleChange}
                    aria-describedby={`${hintId} ${errorId}`}
                    autoComplete="off"
                    format="dd.MM.yyyy HH:mm" // Anzeigeformat mit Uhrzeit
                    timeFormat="HH:mm" // Format für Zeit-Auswahl
                    {...others}
                />
                {showHint && <Hint id={hintId}>{hint}</Hint>}
                {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
            </div>
        </FieldWrapper>
    );
};

CustomDatePicker.displayName = 'CustomDatePicker';
CustomDatePicker.propTypes = {
    valid: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    id: PropTypes.string,
    optional: PropTypes.bool,
    label: PropTypes.string,
    hint: PropTypes.string,
    validationMessage: PropTypes.string,
    visited: PropTypes.bool,
};